var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#BDE9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#69B4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.2955C11.9425 18.8541 11.3384 18.5114 10.6879 18.2675C10.0374 18.0235 9.36368 17.9016 8.66671 17.9016C8.17883 17.9016 7.69966 17.9654 7.22921 18.0932C6.75875 18.221 6.30863 18.4011 5.87883 18.6334C5.63489 18.7612 5.39966 18.7553 5.17315 18.616C4.94663 18.4766 4.83337 18.2733 4.83337 18.0061V9.60762C4.83337 9.47984 4.86532 9.35787 4.92921 9.24171C4.9931 9.12555 5.08893 9.03843 5.21671 8.98035C5.75105 8.70156 6.30863 8.49247 6.88943 8.35307C7.47024 8.21368 8.06267 8.14398 8.66671 8.14398C9.34044 8.14398 9.99966 8.2311 10.6444 8.40535C11.2891 8.57959 11.9076 8.84095 12.5 9.18944V17.6228C13.0925 17.2511 13.7139 16.9723 14.3644 16.7864C15.0149 16.6005 15.6713 16.5076 16.3334 16.5076C16.7516 16.5076 17.161 16.5425 17.5618 16.6122C17.9625 16.6819 18.3662 16.7864 18.7728 16.9258V8.56217C18.947 8.62025 19.1183 8.68123 19.2868 8.74512C19.4552 8.80901 19.6207 8.88742 19.7834 8.98035C19.9112 9.03843 20.007 9.12555 20.0709 9.24171C20.1348 9.35787 20.1667 9.47984 20.1667 9.60762V18.0061C20.1667 18.2733 20.0534 18.4766 19.8269 18.616C19.6004 18.7553 19.3652 18.7612 19.1213 18.6334C18.6915 18.4011 18.2413 18.221 17.7709 18.0932C17.3004 17.9654 16.8213 17.9016 16.3334 17.9016C15.6364 17.9016 14.9627 18.0235 14.3122 18.2675C13.6617 18.5114 13.0576 18.8541 12.5 19.2955ZM13.894 15.8106V9.18944L17.3788 5.70459V12.6743L13.894 15.8106ZM11.1061 16.9432V10.0432C10.7228 9.8806 10.3249 9.75573 9.91254 9.6686C9.50017 9.58148 9.08489 9.53792 8.66671 9.53792C8.23691 9.53792 7.81873 9.57858 7.41216 9.65989C7.0056 9.74121 6.61065 9.86318 6.22731 10.0258V16.9432C6.63388 16.7922 7.03754 16.6819 7.4383 16.6122C7.83906 16.5425 8.24853 16.5076 8.66671 16.5076C9.08489 16.5076 9.49436 16.5425 9.89512 16.6122C10.2959 16.6819 10.6995 16.7922 11.1061 16.9432Z",
    fill: "#016788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLed);
export default __webpack_public_path__ + "static/media/AILed.1490612324adcbf7cc553be84413357f.svg";
export { ForwardRef as ReactComponent };